export enum Country {
  Usa = 'USA',
  Mexico = 'MEX',
}
